/** PRINT_ORIENTATION constants */
export const PRINT_ORIENTATION = {
	LANDSCAPE: "Landscape",
	PORTRAIT: "Portrait",
} as const;

/** PRINT_SIZE constants */
export const PRINT_SIZE = {
	A3: "A3",
	A4: "A4",
	A5: "A5",
	LEGAL: "Legal",
	LETTER: "Letter",
	TABLOID: "Tabloid",
} as const;

/** Printing paper size enum */
export enum PrintSize {
	A3 = "A3",
	A4 = "A4",
	A5 = "A5",
	LEGAL = "Legal",
	LETTER = "Letter",
	TABLOID = "Tabloid",
}

export const FONT_SCALE_PERCENTAGE_DEFAULT = "100";